module.exports = __webpack_public_path__ + "img/1537383380.874105f2.jpg";